import React, { Children } from 'react';
import { get, map, isUndefined } from 'lodash';

// local dependencies
import { useState } from 'react';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { reactiveEpostConfirmation as ReactiveEpostConfirmation } from 'ui/views/widgets/reactiveEpostConfirmation';
 *
 * // render
 * <reactiveEpostConfirmation propName='propValue'/>
 */
export const reactiveEpostConfirmation = (props  ) => {
    console.log(props)
    

    return (
        <div className='ui-reactive-epost-confirmation'>
            
            <div className='ui-reactive-epost-confirmation__header'>

                {/* title for the modal */}
                <div className='ui-reactive-epost-confirmation__header__title'>
                    ReEnroll in Mail Order
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-reactive-epost-confirmation__body'>
               <h1 className='ui-reactive-epost-confirmation__body__subtitle'>To ReEnroll, please contact our Patient Services Team at 1-833-328-4822</h1>
              
            </div>

            {/* actions */}
            <div className='ui-reactive-epost-confirmation__actions'>
                
            <Button
                           
                            size='medium'
                            className='ui-reactive-epost-confirmation__actions__action'
                            outline={  true}
                            label = {{ ref: '', value: 'Cancel' }}
                            onClick={  () => props.closeOverlay() }
                        />
              
                {/* { map( props.actions, action => {

                    let disabled = false;

                    if( 'cancel' !== action.name ) {
                        disabled = isUndefined( selectedVal );
                    }

                    return (
                        <Button
                            key={ action.name }
                            { ...action }
                            size='medium'
                            className='ui-reactive-epost-confirmation__actions__action'
                            outline={ 'cancel' === action.name ? true: false }
                            disabled={ disabled }
                            onClick={ 'cancel' === action.name ? () => props.closeOverlay(): () => props.onSumbitAction( selectedVal ) }
                        />
                    );
                } ) } */}
            </div>


        </div>
    );
};

// set display name
reactiveEpostConfirmation.displayName = 'reactiveEpostConfirmation';

// set default props
reactiveEpostConfirmation.defaultProps = {};

// prop types
reactiveEpostConfirmation.propTypes = {};
